var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11 6.722h3.364V18H1.11V6.722zm1.682-5.605c1.075 0 1.948.91 1.948 2.033 0 1.122-.874 2.031-1.948 2.031-1.075 0-1.948-.91-1.948-2.031 0-1.122.87-2.033 1.948-2.033zM6.688 6.594h3.396v1.56h.048c.473-.897 1.628-1.842 3.35-1.842 3.584 0 4.245 2.36 4.245 5.432v6.255H14.19v-5.545c0-1.323-.023-3.024-1.839-3.024s-2.123 1.441-2.123 2.929V18H6.688V6.594z",
    stroke: "#FFBC00",
    strokeWidth: 0.844,
    strokeMiterlimit: 10
  })));
}
export default __webpack_public_path__ + "21df91755ca13a2852d24f5f9b97e264.svg";
export { SvgLinkdin as ReactComponent };